// DOM
var MyApp = {
    officesFilter: function () {
        var filterState = document.getElementById('filter-state');
        var filterCity = document.getElementById('filter-city');
        var citiesOptions = document.querySelectorAll('option[data-state]');
        
        // change inputs on state selected
        filterState.addEventListener('change', showCities);

        function showCities() {
            var state = this.value;
            var citiesOptionsLength = citiesOptions.length;

            if (state != '') {
                filterCity.disabled = false;
                for (index = 0; index < citiesOptionsLength; index++) {
                    filterCity.remove(1);
                }

                for (counter = 0; counter < citiesOptionsLength; counter++) {
                    if (citiesOptions[counter].dataset.state == state) {
                        var option = document.createElement('option');
                        var optionText = citiesOptions[counter].textContent;
                        var optionValue = citiesOptions[counter].value;
                        option.text = optionText;
                        option.value = optionValue;
                        filterCity.add(option);
                    }
                }
            } else {
                filterCity.disabled = true;
            }
        }

        // filter offices on submit

        var submitButton = document.getElementById('tft-offices-filter__submit');
        var submitError = document.getElementById('tft-offices-filter__error');
        var officesItem = document.querySelectorAll('.tft-offices__item');

        submitButton.addEventListener('click', filterOffices);

        function filterOffices(event) {
            event.preventDefault();
            var selectedState = filterState.value;
            var selectedCity = filterCity.value;
            
            if (selectedState != '' && selectedCity != '') {
                submitError.style.display = 'none';
                for (index = 0; index < officesItem.length; index++) {
                    officesItem[index].style.display = 'none';
                }

                for(counter = 0; counter < officesItem.length; counter++) {
                    if (officesItem[counter].dataset.stateOf == selectedState && officesItem[counter].dataset.cityOf == selectedCity) {
                        officesItem[counter].style.display = 'block';
                    }
                }
            } else {
                submitError.style.display = 'block';
            }
        }

    }
}

// On ready
MyApp.officesFilter();